/**
 * @internal
 * @category Cookie
 */
export const decodeCookieParts = (part) => part.replace(/(%[0-9A-Z]{2})+/g, decodeURIComponent);
